const selectors = {
	print: '.js--print-galleries',
	restart: '.js--print-video-restart'
};

let printGalleriesBox;
let video01;
let prevRatio = 0.0;
const options = {
	root: null,
	rootMargin: '0px',
	threshold: 0.3
};

const videoPlay = video => {
	video.play();
};

const videoStop = video => {
	video.pause();
	video.currentTime = 0;
};

// const slidesStart = video => {
// 	videoPlay(video);
// 	console.log('Start video');
// };

// const slidesStop = video => {
// 	videoStop(video);
// };

const clickRestart = video => {
	const btn = document.querySelector(selectors.restart);

	btn.addEventListener('click', () => {
		videoStop(video);
		videoPlay(video);
	});
};

const handleIntersect = entries => {
	entries.forEach(entry => {
		if (entry.intersectionRatio > prevRatio) {
			videoPlay(video01);
		}

		prevRatio = entry.intersectionRatio;
	});
};

const createObserver = () => {
	let observer;

	observer = new IntersectionObserver(handleIntersect, options); // eslint-disable-line
	observer.observe(printGalleriesBox);
};

const printGalleries = () => {
	window.addEventListener('load', () => {
		printGalleriesBox = document.querySelector(selectors.print);
		video01 = document.getElementById('print-video');

		createObserver();
		clickRestart(video01);
	}, false);
};

const render = () => {
	printGalleries();
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/print-galleries/print-galleries.js